export default __webpack_public_path__ + "static/media/grid.e642d6c6.svg";